const reviews = [
  {
    name: "小鹿同学",
    role: "追漫7年",
    text: "分类真的特别清楚，想找恋爱向的直接进恋爱分类，悬疑烧脑的也一目了然。人气排行也很准，跟着榜单追基本不会踩雷。",
    initial: "鹿",
    color: "bg-primary-500",
  },
  {
    name: "阿哲",
    role: "热血党",
    text: "新作推荐更新特别及时，每周都能第一时间看到新上的热血番。免费专区的作品量也很足，学生党表示很友好！",
    initial: "哲",
    color: "bg-accent-500",
  },
  {
    name: "Momo",
    role: "治愈系爱好者",
    text: "治愈分类里的《猫咪咖啡馆》真的封神！界面干净，看介绍就能大概了解风格，不用点进去才发现不对口味。",
    initial: "M",
    color: "bg-secondary-500",
  },
];

export default function Testimonials() {
  return (
    <section className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <div className="mx-auto max-w-2xl text-center">
        <span className="text-xs font-medium uppercase tracking-wider text-primary-600">读者口碑</span>
        <h2 className="mt-1 font-heading text-2xl text-foreground-950 md:text-3xl">他们都在歪歪漫画网找到好作品</h2>
      </div>
      <div className="mt-10 grid grid-cols-1 gap-4 md:grid-cols-3">
        {reviews.map((r) => (
          <figure
            key={r.name}
            className="rounded-lg border border-background-200/70 bg-background-50 p-6 transition-all duration-300 hover:-translate-y-1 hover:shadow-sm"
          >
            <div className="flex items-center gap-1 text-secondary-500">
              {Array.from({ length: 5 }).map((_, i) => (
                <i key={i} className="ri-star-fill text-sm" />
              ))}
            </div>
            <blockquote className="mt-4 text-sm leading-relaxed text-foreground-700">“{r.text}”</blockquote>
            <figcaption className="mt-5 flex items-center gap-3">
              <span
                className={`flex h-10 w-10 items-center justify-center rounded-full ${r.color} font-heading text-lg text-background-50`}
              >
                {r.initial}
              </span>
              <span>
                <span className="block text-sm font-semibold text-foreground-950">{r.name}</span>
                <span className="block text-xs text-foreground-500">{r.role}</span>
              </span>
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
}